import { render, staticRenderFns } from "./SurfacePostBeingShowed.vue?vue&type=template&id=5571a711&scoped=true&"
import script from "./SurfacePostBeingShowed.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostBeingShowed.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostBeingShowed.vue?vue&type=style&index=0&id=5571a711&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571a711",
  null
  
)

export default component.exports